var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "all-directories" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("directory.allDirectory"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }